import { SET_HEADER_TYPE } from '../actions/types';

export default function headerSettings(state = {}, action) {
	switch (action.type) {
		case SET_HEADER_TYPE:
			return action.payload;
		default:
			return state;
	}
}
